/* eslint-disable hubspot-dev/prefer-hubspot-url-utils */
import styled, { theme, css, mediaQuery } from 'academy-common-lib/utils/Styling';
import UIButton from 'UIComponents/button/UIButton';
import HorizontalLayoutContainer from '../publicLayout/components/HorizontalLayoutContainer';
// @ts-expect-error img
import checkmark from 'bender-url!../../../images/homepage/green-checkmark.svg';
// @ts-expect-error img
import mobileBackground from 'bender-url!../../../images/homepage/corner-blobs.png';
// @ts-expect-error img
import homepageHeroBackground from 'bender-url!../../../images/homepage/white-curved-header.svg';
import PersonaImage from './HeroPersonaImage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getSignupCtaHref } from '../../utils/urls';
import HeroTypingHeading from './HeroTypingHeading';
import { ThemedPrimaryButtonMixin } from '../../components/ThemedComponents';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HeroSection = styled.section.withConfig({
  displayName: "HomepageHeroSection__HeroSection",
  componentId: "sc-16nkxee-0"
})(["text-align:center;box-shadow:inset 0 6px 6px -6px rgba(33,51,67,0.12);background:", " url(", ") bottom;background-size:cover;", " & .persona-image{border-radius:5px;box-shadow:-10px 10px 20px rgba(46,71,93,0.12);position:absolute;", " ", " ", "}& .persona-image--1{transform:rotate(-15deg);top:-5px;left:30px;", "}& .persona-image--2{transform:rotate(15deg);top:200px;left:80px;", "}& .persona-image--3{transform:rotate(15deg);top:-5px;right:30px;", "}& .persona-image--4{transform:rotate(-15deg);top:200px;right:80px;", "}& .persona-image--5{transform:rotate(-15deg);top:20px;left:150px;", "}& .persona-image--6{transform:rotate(15deg);top:20px;right:150px;", "}"], theme.colors.GYPSUM, homepageHeroBackground, mediaQuery('mobile', css(["background:url(", ") no-repeat bottom right;background-size:80%;"], mobileBackground)), mediaQuery('laptop', css(["display:none;"])), mediaQuery('notLaptop', css(["width:120px;height:90px;"])), mediaQuery('desktop', css(["width:170px;height:130px;"])), mediaQuery('desktop', css(["top:-15px;"])), mediaQuery('desktop', css(["top:220px;left:90px;"])), mediaQuery('desktop', css(["top:-15px;"])), mediaQuery('desktop', css(["top:220px;right:90px;"])), mediaQuery('desktop', css(["top:90px;left:290px;"])), mediaQuery('desktop', css(["top:90px;right:290px;"])));
const HeroContainer = styled.div.withConfig({
  displayName: "HomepageHeroSection__HeroContainer",
  componentId: "sc-16nkxee-1"
})(["position:relative;", ""], mediaQuery('notLaptop', css(["display:grid;grid-template-columns:1fr 2fr 1fr;"])));
const HeroContent = styled.div.withConfig({
  displayName: "HomepageHeroSection__HeroContent",
  componentId: "sc-16nkxee-2"
})(["padding-top:48px;padding-inline:32px;"]);
const HeroDescription = styled.p.withConfig({
  displayName: "HomepageHeroSection__HeroDescription",
  componentId: "sc-16nkxee-3"
})(["font-weight:600;line-height:1.6;", ""], mediaQuery('notMobile', css(["font-size:16px;"])));
const HeroButton = styled(UIButton).attrs({
  use: 'primary'
}).withConfig({
  displayName: "HomepageHeroSection__HeroButton",
  componentId: "sc-16nkxee-4"
})(["padding:16px 32px !important;", " ", ""], ThemedPrimaryButtonMixin, mediaQuery('notMobile', css(["font-size:16px !important;"])));
const PersonaBottom = styled.div.withConfig({
  displayName: "HomepageHeroSection__PersonaBottom",
  componentId: "sc-16nkxee-5"
})(["grid-column:1 / -1;padding-bottom:160px;position:relative;", ""], mediaQuery('tablet', css(["padding-bottom:128px;"])));
const HeroBenefits = styled.ul.withConfig({
  displayName: "HomepageHeroSection__HeroBenefits",
  componentId: "sc-16nkxee-6"
})(["list-style:none;font-size:16px;font-weight:600;padding-left:0;width:fit-content;margin:0 auto;", " li{display:inline-block;", "}li::before{content:url(", ");display:inline;line-height:110%;margin-right:8px;vertical-align:middle;}"], mediaQuery('notMobile', css(["display:flex;flex-wrap:wrap;justify-content:center;column-gap:22px;"])), mediaQuery('mobile', css(["font-size:14px;display:flex;margin-bottom:12px;text-align:left;"])), checkmark);
const HomepageHeroSection = () => {
  return /*#__PURE__*/_jsx(HeroSection, {
    className: "academy-homepage-hero-section",
    children: /*#__PURE__*/_jsx(HorizontalLayoutContainer, {
      size: "large",
      children: /*#__PURE__*/_jsxs(HeroContainer, {
        children: [/*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(PersonaImage, {
            imageNumber: 1
          }), /*#__PURE__*/_jsx(PersonaImage, {
            imageNumber: 2
          })]
        }), /*#__PURE__*/_jsxs(HeroContent, {
          children: [/*#__PURE__*/_jsx(HeroTypingHeading, {}), /*#__PURE__*/_jsx(HeroDescription, {
            className: "m-bottom-6",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "academyPublic.homepage.heroSection.description"
            })
          }), /*#__PURE__*/_jsx(HeroButton, {
            href: getSignupCtaHref('academy-home-hero'),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "academyPublic.homepage.heroSection.ctaText"
            })
          }), /*#__PURE__*/_jsxs(HeroBenefits, {
            className: "m-top-8",
            children: [/*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "academyPublic.homepage.heroSection.benefits1"
              })
            }), /*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "academyPublic.homepage.heroSection.benefits2"
              })
            }), /*#__PURE__*/_jsx("li", {
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "academyPublic.homepage.heroSection.benefits3"
              })
            })]
          })]
        }), /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(PersonaImage, {
            imageNumber: 3
          }), /*#__PURE__*/_jsx(PersonaImage, {
            imageNumber: 4
          })]
        }), /*#__PURE__*/_jsxs(PersonaBottom, {
          children: [/*#__PURE__*/_jsx(PersonaImage, {
            imageNumber: 5
          }), /*#__PURE__*/_jsx(PersonaImage, {
            imageNumber: 6
          })]
        })]
      })
    })
  });
};
export default HomepageHeroSection;